<template>
  <div>
    <!-- ---------- HERO ---------- -->
    <section class="hero">
      <b-container>
        <div class="hero-grid">
          <div class="hero-text" v-reveal>
            <span class="eyebrow">{{ t.hero_tagline }}</span>
            <h1 class="hero-title">
              <span class="text-gradient">Club Baby Pro</span>
            </h1>
            <p class="hero-lead">{{ t.hero_lead }}</p>
            <div class="hero-actions">
              <router-link to="/stellar-collect" class="btn-cbp">
                {{ t.hero_cta_discover }}
              </router-link>
              <router-link to="/laowai-survival" class="btn-ghost">
                {{ t.hero_cta_laowai }}
              </router-link>
            </div>
          </div>

          <div class="hero-visual" v-reveal>
            <div class="hero-glow"></div>
            <img
              :src="require('@/assets/home_phone.png')"
              alt="Aperçu du jeu Hot Pursuit sur mobile"
              class="hero-phone"
              loading="eager" />
          </div>
        </div>
      </b-container>
    </section>

    <!-- ---------- TEASER PROJET ---------- -->
    <section class="section projects">
      <b-container>
        <div class="section-head" v-reveal>
          <span class="eyebrow">{{ t.projects_eyebrow }}</span>
          <h2 class="section-title">{{ t.projects_title }}</h2>
        </div>

        <div class="games-grid">
          <router-link to="/stellar-collect" class="game-card card-cbp" v-reveal>
            <div class="game-card-media sc-card-media">
              <img :src="require('@/assets/stellar-collect/feature-graphic.png')" alt="Stellar Collect" loading="lazy" />
            </div>
            <div class="game-card-body">
              <span class="eyebrow game-card-label">{{ t.sc_new_game_label }}</span>
              <h3 class="game-card-title">Stellar Collect</h3>
              <p class="game-card-text">{{ t.sc_card_text }}</p>
              <span class="game-card-link">
                {{ t.learn_more }}
                <span aria-hidden="true">→</span>
              </span>
            </div>
          </router-link>

          <router-link to="/laowai-survival" class="game-card game-card-reverse card-cbp" v-reveal>
            <div class="game-card-media laowai-card-media">
              <img :src="require('@/assets/laowai-survival/feature-graphic.png')" alt="Laowai Survival" loading="lazy" />
            </div>
            <div class="game-card-body">
              <h3 class="game-card-title">Laowai Survival</h3>
              <p class="game-card-text">{{ t.laowai_card_text }}</p>
              <span class="game-card-link">
                {{ t.learn_more }}
                <span aria-hidden="true">→</span>
              </span>
            </div>
          </router-link>

          <router-link to="/hotpursuit" class="game-card card-cbp" v-reveal>
            <div class="game-card-media">
              <img :src="require('@/assets/home.jpg')" alt="Hot Pursuit" loading="lazy" />
            </div>
            <div class="game-card-body">
              <h3 class="game-card-title">Hot Pursuit</h3>
              <p class="game-card-text">{{ t.game_teaser }}</p>
              <span class="game-card-link">
                {{ t.learn_more }}
                <span aria-hidden="true">→</span>
              </span>
            </div>
          </router-link>
        </div>
      </b-container>
    </section>
  </div>
</template>

<script>
import en from '@/en'
import fr from '@/fr'

export default {
  name: 'HomePage',
  data () {
    return {
      languages: {
        en,
        fr
      }
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    t () {
      return this.languages[this.language]
    }
  }
}
</script>

<style scoped lang="scss">
  /* ---------- HERO ---------- */
  .hero {
    padding: clamp(3rem, 7vw, 6rem) 0 clamp(2rem, 5vw, 4rem);
    position: relative;
  }

  .hero-grid {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    align-items: center;
    gap: clamp(2rem, 5vw, 4rem);
  }

  .hero-text {
    text-align: left;
  }

  .hero-title {
    font-size: clamp(3.4rem, 9vw, 6.5rem);
    margin: 0 0 1.2rem;
    line-height: 0.92;
    /* Relief "arcade" net : ombre solide empilée, sans flou */
    text-shadow:
      0 1px 0 #15803d,
      0 2px 0 #15803d,
      0 3px 0 #166534,
      0 4px 5px rgba(20, 83, 45, 0.28);
  }

  .hero-lead {
    color: var(--text-muted);
    font-size: clamp(1rem, 1.6vw, 1.2rem);
    max-width: 46ch;
    margin: 0 0 2rem;
  }

  .hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .btn-ghost {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.85rem 1.5rem;
    border-radius: 999px;
    border: 1px solid var(--border-strong);
    color: var(--text);
    text-decoration: none;
    font-family: 'agency', sans-serif;
    font-size: 1.1rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
  }
  .btn-ghost:hover,
  .btn-ghost:focus {
    border-color: var(--gold);
    background: rgba(34, 197, 94, 0.10);
    color: var(--text);
    text-decoration: none;
    transform: translateY(-2px);
  }

  .hero-visual {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .hero-glow {
    position: absolute;
    inset: 12% 6%;
    background: radial-gradient(ellipse at center, rgba(34, 197, 94, 0.22), transparent 68%);
    filter: blur(45px);
    z-index: 0;
  }
  .hero-phone {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 640px;
    height: auto;
    filter: drop-shadow(0 26px 44px rgba(20, 28, 45, 0.30));
    animation: float 6s ease-in-out infinite;
  }

  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-14px); }
  }
  @media (prefers-reduced-motion: reduce) {
    .hero-phone { animation: none; }
  }

  /* ---------- SECTION PROJETS ---------- */
  .section-head {
    text-align: center;
    margin-bottom: 2.5rem;
  }
  .section-title {
    font-size: clamp(2.4rem, 6vw, 3.8rem);
  }
  .games-grid {
    display: grid;
    gap: 1.75rem;
  }

  .game-card {
    display: grid;
    grid-template-columns: 1fr 1fr;
    overflow: hidden;
    text-align: left;
    color: inherit;
    text-decoration: none;
    outline: none;
    transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  }
  .game-card-reverse .game-card-media {
    order: 2;
  }
  .game-card:hover,
  .game-card:focus,
  .game-card:active {
    text-decoration: none;
    outline: none;
  }
  .game-card:hover {
    transform: translateY(-6px);
    border-color: var(--gold);
    box-shadow: 0 26px 50px -20px rgba(0, 0, 0, 0.8);
  }
  /* Accessibilité : contour visible uniquement au clavier, sans le "rectangle" à la souris */
  .game-card:focus-visible {
    outline: 2px solid var(--gold);
    outline-offset: 4px;
  }

  .game-card-media {
    overflow: hidden;
  }
  .game-card-media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  .laowai-card-media {
    background: #f59e0b;
  }
  .sc-card-media {
    background: #150c2b;
  }
  .game-card:hover .game-card-media img {
    transform: scale(1.06);
  }

  .game-card-body {
    padding: clamp(1.5rem, 3vw, 2.5rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .game-card-title {
    font-family: 'fightt', sans-serif;
    font-size: clamp(2.2rem, 5vw, 3.2rem);
    margin-bottom: 0.75rem;
  }
  .game-card-label {
    font-size: 0.82rem;
    letter-spacing: 2px;
    margin-bottom: 0.5rem;
  }
  .game-card-text {
    color: var(--text-muted);
    margin-bottom: 1.5rem;
  }
  .game-card-link {
    font-family: 'agency', sans-serif;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--gold);
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .game-card:hover .game-card-link span[aria-hidden] {
    transform: translateX(4px);
  }
  .game-card-link span[aria-hidden] {
    transition: transform 0.2s ease;
  }

  /* ---------- Responsive ---------- */
  @media (max-width: 850px) {
    .hero-grid {
      grid-template-columns: 1fr;
      text-align: center;
    }
    .hero-text {
      text-align: center;
    }
    .hero-lead {
      margin-left: auto;
      margin-right: auto;
    }
    .hero-actions {
      justify-content: center;
    }
    .hero-visual {
      order: -1;
    }
    .hero-phone {
      max-width: 460px;
    }
    .game-card {
      grid-template-columns: 1fr;
    }
    .game-card-reverse .game-card-media {
      order: 0;
    }
    .game-card-media {
      max-height: 240px;
    }
  }
</style>
